<template>
	<article class="question-card">
    <div class="question-wrapper">
      <p class="q emphasis-skyblue">Q.</p>
      <p class="question-text">{{q}}</p>
    </div>
    <div class="answer-wrapper">
      <p class="a emphasis">A.</p>
      <p class="answer-text">{{a}}</p>
    </div>
	</article>
</template>

<script>
export default {
  name: 'QuestionCard',
  props: {
    q: {
      type: String,
      required: false,
      default: ''
    },
    a: {
      type: String,
      required: false,
      default: ''
    },
  }
}
</script>

<style lang="scss" scoped>
.question-card {
  max-width: 640px;
  width: 100%;
  border-radius: 6px;
  box-shadow: 0 0 10px 0 rgba(0,0,0,.1);
  margin: auto;
  background-color: #fefefe;
  padding: 32px;
}
.emphasis-skyblue {
  font-size: 38px;
  color: #89EFF6;
  font-weight: bold;
}
.question-text {
  font-size: 22px;
  font-weight: bold;
}
.question-wrapper, .answer-wrapper {
  display: flex;
  align-items: center;
}
.answer-wrapper {
  margin-top: 24px;
}
.q, .a {
  padding-right: 16px;
}
@media screen and (max-width: 896px) {
  .emphasis-skyblue {
    font-size: 26px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LP/atoms/QuestionCard.vue